import { pickBy, toPairs } from 'lodash';


export function parameterObjectToQuery<T extends Object>(parameters: T): string {
  const removeUndefined = pickBy(parameters, v => v !== undefined);
  const params = toPairs(removeUndefined).map(([param, value]: [string, string|number|undefined|string[]]) => {
    const val = Array.isArray(value) ? value.join(',') : value;
    return `${param}=${encodeURIComponent(val as any)}`;
  });
  return (params.length > 0) ? `?${params.join("&")}` : '';
}
